import { formatPrice } from "helpers";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "helpers/DrawerActions";
import getCurrency from "helpers/currencyHelper";
import { store } from "store/store";



function Price(props: { price?: number; currency?: Currency }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-dark-3">
        {props.currency?.en_title || getCurrency()?.defCur?.en_title}
      </span>
      <span className="text-sm text-dark-2">{formatPrice(props.price || 0)}</span>
    </div>
  );
}

const userAccountCardFactorsColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    disableSearch: true,
    getValue: (item: any) => item.factor?.accountingCode || "-",
  },
  {
    name: "عنوان",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    disableSearch: true,
    clickable: () => true,
    onClick: (dispatch: any, item: any) => {
      openFactorDrawer(dispatch, item.factor);
    },
    getValue: (item: any) => item.factor?.title || "-",
  },
  {
    name: "مشتری",
    key: "Person",
    searchKey: "nickName",
    filterParams: {
      column: "nickName",
      columnType: "string",
    },
    disableSearch: true,
    navigateKey: (item: any) => item.factor?.PersonId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: "autocomplete",
    dataKey: {
      column: "persons",
      key: "nickName",
    },
    getValue: (item: any) => item.factor?.Person?.nickName ?? "-",
  },
  {
    name: "مبلغ",
    key: "totalAmount",
    getValue: (item: any) => 
      `${formatPrice(item?.totalAmount || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
    // <Price price={item?.totalAmount} currency={item?.factor?.Currency} />,
    filterParams: {
      column: "price",
      columnType: "number",
    },
    searchType: "quantitative",
  },
  {
    name: "تاریخ ثبت",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    disableSearch: true,
    searchType: "date",
  },
  {
    name: "وضعیت",
    key: "status",
    size: "2",
    disableSearch: true,
    searchType: "status",
    mainColumn: true,
    dataKey: [
      { label: "دریافت شده", value: "دریافت شده", id: 1 },
      { label: "تایید شده", value: "تایید شده", id: 2 },
      { label: "پیش نویس", value: "پیش نویس", id: 3 },
    ],
    getValue: (item: any) => item.factor?.status,
  },
];

const userAccountCardTransactionsColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    disableSearch: true,
    getValue: (item: any) => item.transaction?.accountingCode || "-",
  },
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    disableSearch: true,
    searchType: "date",
  },
  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "description",
      columnType: "string",
    },
    disableSearch: true,
    clickable: () => true,
    onClick: (dispatch: any, item: any) => {
      openTransactionDrawer(dispatch, { id: item.transaction?.id });
    },
    getValue: (item: any) => item.transaction?.description || "---------",
  },
  {
    name: "مبلغ",
    key: "amount",
    filterParams: {
      column: "amount",
      columnType: "number",
    },
    disableSearch: true,
    getValue: (item: any) => <Price price={item?.totalAmount} currency={item?.transaction?.Currency} />,
    searchType: "quantitative",
  },
];
const userAccountCardAccountingColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    disableSearch: true,
    getValue: (item: any) => item.accounting?.accountingCode || "-",
  },
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    disableSearch: true,
    showDatePicker: true,
    searchType: "date",
  },
  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "description",
      columnType: "string",
    },
    disableSearch: true,
    clickable: () => true,
    onClick: (dispatch: any, res: any) => {
      const item = res?.accounting;
      if (item?.type && item?.type_id) {
        if (item.type === "factor") {
          openFactorDrawer(dispatch, item);
        } else if (item.type === "transaction") {
          openTransactionDrawer(dispatch, item);
        } else if (item.type === "transfer") {
          openTransferDrawer(dispatch, item);
        } else if (item.type === "bill") {
          openRemittanceDrawer(dispatch, item);
        }
      } else if (item) {
        openAccountingDrawer(dispatch, item);
      }
    },
    getValue: (item: any) => item.accounting?.description || "-----",
  },
  {
    name: "مبلغ",
    key: "amount",
    filterParams: {
      column: "amount",
      columnType: "number",
    },
    disableSearch: true,
    searchType: "quantitative",
    getValue: (item: any) => <Price price={item?.totalAmount} currency={item?.accounting?.Currency} />,
  },
];
const userAccountCardBillsColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    disableSearch: true,
    getValue: (item: any) => item.bill?.accountingCode || "-",
  },
  {
    name: "تاریخ",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    disableSearch: true,
    searchType: "date",
  },
  {
    name: "انبار",
    key: "Warehouse",
    getValue: (item: any) => item.bill?.Warehouse?.title,
    navigateKey: (item: any) => item.bill?.Warehouse?.id,
    navigate: "/inventories/supply?warehouseId=",
    filterParams: {
      column: "name",
      columnType: "string",
    },
    disableSearch: true,
    searchType: "autocomplete",
    dataKey: {
      column: "inventories",
      key: "title",
    },
  },
  {
    name: "نوع",
    key: "factor_type",
    filterParams: {
      column: "type",
      columnType: "string",
    },
    disableSearch: true,
    getValue: (item: any) => {
      switch (item.bill?.type) {
        case "exit":
          return "خروج";
        case "enter":
          return "ورود";
      }
    },
    searchType: "status",
    dataKey: [
      { label: "خروج", value: "exit", id: 1 },
      { label: "ورود", value: "enter", id: 2 },
    ],
  },
  {
    name: "شرح",
    key: "description",
    filterParams: {
      column: "description",
      columnType: "string",
    },
    disableSearch: true,
    clickable: () => true,
    onClick: (dispatch: any, item: any) => {
      openRemittanceDrawer(dispatch, item.bill);
    },
    getValue: (item: any) => item.bill?.description || "-------",
  },
];

export const userAccountCardIndexData = [
  {
    key: "userAccountFactors",
    apiKey:"factors",
    disableSearch: true,
    title: "فاکتورها",
    tableColumns: userAccountCardFactorsColumns,
    disableDateFilter: true,
    actions: {},
  },
  {
    key: "userAccountTransactions",
    apiKey:"transactions",
    disableSearch: true,
    title: "تراکنش ها",
    tableColumns: userAccountCardTransactionsColumns,
    disableDateFilter: true,
    actions: {},
  },
  {
    key: "userAccountAccountings",
    apiKey:"accountings",
    disableSearch: true,
    title: "اسناد حسابداری",
    tableColumns: userAccountCardAccountingColumns,
    disableDateFilter: true,
    actions: {},
  },
  {
    key: "userAccountBills",
    apiKey:"bills",
    disableSearch: true,
    title: "حواله های انبار",
    tableColumns: userAccountCardBillsColumns,
    disableDateFilter: true,
    actions: {},
  },
];
